module.exports = __webpack_public_path__ + "media/src/website/images/locations/germering/03-ac7d45c2bcae037855a4295ff6504e9f.jpg";